const setStorage = (key: string, data: any): void => {
  try {
    const jsonData = JSON.stringify(data);
    localStorage.setItem(key, jsonData);
  } catch {
    throw Error("Error saving in local storage");
  }
};

const getStorage = (key: string): any | null => {
  try {
    const jsonData = localStorage.getItem(key);
    return jsonData ? JSON.parse(jsonData) : null;
  } catch {
    return null;
  }
};

const deleteStorage = (key: string): boolean | null => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return null;
  }
};

export { setStorage, getStorage, deleteStorage };
